import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BorderModel} from '../dto/border.model';
import {Observable} from 'rxjs/internal/Observable';
import {SearchBoderRequestDetailModel} from '../../model/search.border.request.details.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class BorderService {
  borderSearchDetailsChange = new EventEmitter<BorderModel[]>();
  private borderSearchDetailsItem: BorderModel[] = [];

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  /**Save Border Details **/
  saveBodyDetails(borderDTO: BorderModel) {
    return this.httpClient.post(this.BASE_URL + 'bordercontrol/save' , borderDTO,{responseType: 'text'});
  }

  /** Get all Border details **/
  getAllBorderDetails(){
    return this.httpClient.get(this.BASE_URL + 'bordercontrol/all');
  }

  /** Search Border Details **/
  searchBorder(borderDTO: BorderModel){
    return this.httpClient.post(this.BASE_URL + 'bordercontrol/search', borderDTO, { headers: this.headers });
  }

  /** Delete Border details **/
  deleteBorderDetails(code: string){
    return this.httpClient.delete(this.BASE_URL + 'bordercontrol/delete/'+code, { headers: this.headers });
  }

  /** Search Border Details **/
  getBorderDetails(borderDTO: SearchBoderRequestDetailModel): Observable<Object>{
    return this.httpClient.post(this.BASE_URL + 'bordercontrol/search/', borderDTO, { headers: this.headers });
  }

  getAllBoderDetails(): Observable<object>{
    return this.httpClient.get(this.BASE_URL + 'bordercontrol/getAll/');
  }

  /** reset searched details **/
  clearBorderSearchDetails() {
    this.borderSearchDetailsItem = [];
    this.borderSearchDetailsChange.emit(this.borderSearchDetailsItem);
  }

  /** set search details in the table **/
  setBorderSearchDetails(borderDetails: BorderModel[]) {
    this.borderSearchDetailsItem = borderDetails;
    this.borderSearchDetailsChange.emit(this.borderSearchDetailsItem);
  }

  getAllCountries(){
    return this.httpClient.get(this.BASE_URL + 'bordercontrol/getAllCountries');
  }

  /** Save Employee Designations **/
  saveBorderDetails(designationDTO: BorderModel) {
    return this.httpClient.post(this.BASE_URL + 'bordercontrol/save' , designationDTO,{responseType: 'text'});
  }


  /** Delete Employee Details **/
  deleteEmployee(id: string) {
    return this.httpClient.delete(this.BASE_URL + 'bordercontrol/delete/'+ id,{headers: this.headers});
  }
}
